import {
  adminInput,
  adminButtonPrimary,
  adminSectionTitle,
  adminModalPanel,
} from '../../layout/adminStyles';
import React, { FC, FormEvent } from 'react';
import { CategoryForm } from './categoryForm';

type Props = {
  isShowModal: boolean;
  form: CategoryForm;
  isSaving: boolean;
  onChange: (form: CategoryForm) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const CategoryCreateModal: FC<Props> = ({
  isShowModal,
  form,
  isSaving,
  onChange,
  onClose,
  onSubmit,
}) => {
  if (!isShowModal) {
    return null;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="category-create-modal-title"
    >
      <div className={adminModalPanel}>
        <div className="mb-4 flex items-center justify-between border-b border-stone-200 pb-3">
          <h2 id="category-create-modal-title" className={adminSectionTitle + ' mb-0 border-0 pb-0'}>
            新規カテゴリ登録
          </h2>
          <button
            type="button"
            className="text-2xl leading-none text-stone-500 hover:text-stone-800"
            onClick={onClose}
            aria-label="閉じる"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="create-category-name" className="mb-1 block text-sm font-medium text-stone-700">
              カテゴリ名
            </label>
            <input
              id="create-category-name"
              type="text"
              required
              className={`${adminInput} w-full`}
              value={form.name}
              onChange={(e) => onChange({ ...form, name: e.target.value })}
            />
          </div>

          <div className="mb-6">
            <label htmlFor="create-category-display-order" className="mb-1 block text-sm font-medium text-stone-700">
              表示順
            </label>
            <input
              id="create-category-display-order"
              type="number"
              required
              className={`${adminInput} w-full`}
              value={form.display_order}
              onChange={(e) => onChange({ ...form, display_order: e.target.value })}
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-xl border border-stone-300 px-5 py-2 text-stone-700 hover:bg-stone-50"
              onClick={onClose}
              disabled={isSaving}
            >
              キャンセル
            </button>
            <button type="submit" className={adminButtonPrimary} disabled={isSaving}>
              {isSaving ? '登録中...' : '登録'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryCreateModal;
